import Vue from 'vue'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'

// import 'vue-toast-notification/dist/theme-default.css';

Vue.use(VueToast)
export default VueToast
